import { useMemo } from 'react';

import { useGetSpringBigOffersQuery } from 'src/app/queries/discounts/get-springbig-offers';

export function useSpringBigOffers(enabled = true) {
  const { data, isLoading } = useGetSpringBigOffersQuery(enabled);

  return useMemo(
    () => ({ isLoading, options: data?.map((offer) => ({ id: offer.meta, label: offer.name })) ?? [] }),
    [data, isLoading]
  );
}
